var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "workflow-archival", class: { loading: _vm.loading } },
    [
      !_vm.loading && !_vm.isArchivalEnabled
        ? _c("archival-disabled-messaging", {
            attrs: { "domain-settings": _vm.domainSettings }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.isArchivalEnabled
        ? _c("router-view", {
            attrs: {
              name: "workflow-archival-advanced",
              "cluster-name": _vm.clusterName,
              "date-format": _vm.dateFormat,
              domain: _vm.domain,
              timeFormat: _vm.timeFormat,
              timezone: _vm.timezone
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.isArchivalEnabled
        ? _c("router-view", {
            attrs: {
              name: "workflow-archival-basic",
              "cluster-name": _vm.clusterName,
              "date-format": _vm.dateFormat,
              domain: _vm.domain,
              timeFormat: _vm.timeFormat,
              timezone: _vm.timezone
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00220ea3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00220ea3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/domain/workflow-archival/index.vue
// module id = 1765
// module chunks = 0